// This file was autogenerated. Do not edit directly.

import { baseColorTokens } from './baseColorTokens';

export const lightThemeTokens = {
    backgroundContrastHigh: baseColorTokens.warmGray200,
    backgroundContrastInverse: baseColorTokens.warmGray1000,
    backgroundContrastMedium: baseColorTokens.warmGray100,
    backgroundContrastNone: baseColorTokens.brandWhite,
    backgroundDataBlue: baseColorTokens.blue200,
    backgroundDataCyan: baseColorTokens.cyan200,
    backgroundDataPurple: baseColorTokens.violet200,
    backgroundDataSeafoam: baseColorTokens.seafoam200,
    backgroundDataYellow: baseColorTokens.yellow200,
    backgroundInteractiveNegativeHovered: baseColorTokens.red200,
    backgroundInteractiveNegativePressed: baseColorTokens.red300,
    backgroundInteractiveNegativeResting: baseColorTokens.red100,
    backgroundInteractivePositiveHovered: baseColorTokens.seafoam200,
    backgroundInteractivePositivePressed: baseColorTokens.seafoam300,
    backgroundInteractivePositiveResting: baseColorTokens.seafoam100,
    backgroundInteractiveProminentHovered: baseColorTokens.blue200,
    backgroundInteractiveProminentPressed: baseColorTokens.blue300,
    backgroundInteractiveProminentResting: baseColorTokens.blue100,
    backgroundStatusCaution: baseColorTokens.yellow200,
    backgroundStatusDisabled: baseColorTokens.warmGray300,
    backgroundStatusInfo: baseColorTokens.violet200,
    backgroundStatusNegative: baseColorTokens.red200,
    backgroundStatusNeutral: baseColorTokens.warmGray200,
    backgroundStatusPositive: baseColorTokens.seafoam200,
    backgroundStatusProminent: baseColorTokens.blue200,
    baseNeutralHovered: baseColorTokens.warmGray200,
    baseNeutralPressed: baseColorTokens.warmGray300,
    baseNeutralResting: baseColorTokens.warmGray100,
    graphicContrastHigh: baseColorTokens.warmGray900,
    graphicContrastInverse: baseColorTokens.brandWhite,
    graphicContrastLow: baseColorTokens.warmGray300,
    graphicContrastMedium: baseColorTokens.warmGray500,
    graphicDataBlue: baseColorTokens.blue500,
    graphicDataCyan: baseColorTokens.cyan500,
    graphicDataPurple: baseColorTokens.violet500,
    graphicDataSeafoam: baseColorTokens.seafoam500,
    graphicDataYellow: baseColorTokens.yellow400,
    graphicInteractiveNegativeHovered: baseColorTokens.red700,
    graphicInteractiveNegativePressed: baseColorTokens.red800,
    graphicInteractiveNegativeResting: baseColorTokens.red600,
    graphicInteractiveNeutralHovered: baseColorTokens.warmGray600,
    graphicInteractiveNeutralPressed: baseColorTokens.warmGray700,
    graphicInteractiveNeutralResting: baseColorTokens.warmGray500,
    graphicInteractiveProminentHovered: baseColorTokens.blue700,
    graphicInteractiveProminentPressed: baseColorTokens.blue800,
    graphicInteractiveProminentResting: baseColorTokens.blue600,
    graphicStatusCaution: baseColorTokens.yellow500,
    graphicStatusDisabled: baseColorTokens.warmGray400,
    graphicStatusInfo: baseColorTokens.violet500,
    graphicStatusNegative: baseColorTokens.red500,
    graphicStatusNeutral: baseColorTokens.warmGray500,
    graphicStatusPositive: baseColorTokens.seafoam500,
    graphicStatusProminent: baseColorTokens.blue600,
    textContrastHigh: baseColorTokens.warmGray900,
    textContrastInverse: baseColorTokens.brandWhite,
    textContrastLow: baseColorTokens.warmGray700,
    textContrastMedium: baseColorTokens.warmGray800,
    textContrastMinimum: baseColorTokens.warmGray600,
    textDataBlue: baseColorTokens.blue600,
    textDataCyan: baseColorTokens.cyan600,
    textDataPurple: baseColorTokens.violet600,
    textDataSeafoam: baseColorTokens.seafoam600,
    textDataYellow: baseColorTokens.yellow600,
    textInteractiveNegativeHovered: baseColorTokens.red700,
    textInteractiveNegativePressed: baseColorTokens.red800,
    textInteractiveNegativeResting: baseColorTokens.red600,
    textInteractiveNeutralHovered: baseColorTokens.warmGray800,
    textInteractiveNeutralPressed: baseColorTokens.warmGray900,
    textInteractiveNeutralResting: baseColorTokens.warmGray700,
    textInteractiveProminentHovered: baseColorTokens.blue700,
    textInteractiveProminentPressed: baseColorTokens.blue800,
    textInteractiveProminentResting: baseColorTokens.blue600,
    textStatusCaution: baseColorTokens.yellow600,
    textStatusDisabled: baseColorTokens.warmGray400,
    textStatusInfo: baseColorTokens.violet600,
    textStatusNegative: baseColorTokens.red600,
    textStatusNeutral: baseColorTokens.warmGray600,
    textStatusPositive: baseColorTokens.seafoam600,
    textStatusProminent: baseColorTokens.blue600,
};
